import { RouteLocationNormalized, NavigationGuardNext } from 'vue-router';

const authGuard = ({
  to,
  next,
}: {
  to: RouteLocationNormalized;
  from: RouteLocationNormalized;
  next: NavigationGuardNext;
}) => {
  const storage = JSON.parse(localStorage.getItem('auth') as string);
  const isAuthenticated = storage ? !!storage.token : false;

  if (to.meta.requiresAuth && !isAuthenticated) {
    next({ name: 'login' });
  } else {
    next();
  }
};

export default authGuard;
